import { memo } from "react";
import { useParams } from "react-router-dom";

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import LinkTab from "layouts/components/LinkTab";

import General from "./General";
import SupportAccess from "./SupportAccess";
import TrustCenter from "./TrustCenter";

// -----------------------------------------------------------------------------

const OrganizationSettingsPage = memo(
  function OrganizationSettingsPage(): JSX.Element {
    const { module } = useParams() as any;
    const moduleId = getModuleId(module);

    //
    return (
      <>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Organization Settings
        </Typography>
        <Tabs value={moduleId}>
          <LinkTab label="General" to="/organization/settings/general" />
          <LinkTab
            label="Support Access"
            to="/organization/settings/support-access"
          />
          <LinkTab
            label="Trust &amp; Compliance"
            to="/organization/settings/trust-center"
          />
        </Tabs>
        <Box sx={{ mt: 3 }}>{renderTab(moduleId)}</Box>
      </>
    );
  }
);

export default OrganizationSettingsPage;

// -----------------------------------------------------------------------------

function renderTab(value: number): JSX.Element {
  switch (value) {
    case 0:
      return <General />;

    case 1:
      return <SupportAccess />;

    case 2:
      return <TrustCenter />;
    default:
      return <General />;
  }
}

function getModuleId(module: string): number {
  switch (module) {
    case "support-access":
      return 1;
    case "trust-center":
      return 2;
    default:
      return 0;
  }
}
